import React from 'react';
import styled from 'styled-components';

const DivPreview = styled.div`
  width: 100%; 
  height: 100%;
  position: relative;
  text-align: center;
`;

const ImgPreview = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 0.1rem;
`;

function ImagePreview({ dataUri, isFullscreen }) {
  return (
    <DivPreview>
      <ImgPreview src={dataUri} alt="Signature selfie" />
    </DivPreview>
  );
}

export default ImagePreview;
